import x from "./x.png"

const XIcon = () => {
  return (
    <img
      src={x}
      width="40"
      height="40"
      viewBox="0 0 80 80"
      fill="none"
      
    >
     
    </img>
  )
}

export default XIcon;